import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/partners/kh-logo.svg")